import type { PurchaseOrderPart } from '../../../types/inventory/purchaseOrders';

/** Number of line items on the PO (after cost-lot rows are collapsed by partId). */
export function purchaseOrderPartCount(parts: PurchaseOrderPart[]): number {
    return parts.length;
}

/** Sum of quantity × buy price across the line items. */
export function purchaseOrderValue(parts: PurchaseOrderPart[]): number {
    return parts.reduce((sum, part) => sum + part.quantity * part.buyPrice, 0);
}

/**
 * Longest delivery ETA in days across the line items, preferring any unsaved
 * draft for a part. Null when there are no parts.
 */
export function purchaseOrderEtaDays(
    parts: PurchaseOrderPart[],
    daysDrafts: Record<string, number> = {},
): number | null {
    if (parts.length === 0) return null;
    return parts.reduce(
        (max, part) => Math.max(max, daysDrafts[part.partId] ?? part.deliveryDays),
        Number.NEGATIVE_INFINITY,
    );
}

/** (list − buy) / list as a percentage; null when the list price is not positive. */
export function grossMarginPercent(listPrice: number, buyPrice: number): number | null {
    if (!Number.isFinite(listPrice) || listPrice <= 0) return null;
    return ((listPrice - buyPrice) / listPrice) * 100;
}

export function formatGrossMargin(listPrice: number, buyPrice: number): string {
    const margin = grossMarginPercent(listPrice, buyPrice);
    return margin === null ? '—' : `${margin.toFixed(1)}%`;
}
